<template>
  <!-- 사장님 계정 매장 고르기 — POS2 Lite `OwnerStorePicker` 와 같은 말·같은 순서(매장 추가 단추는 앱에만 있다) -->
  <div class="owner-picker">
    <owner-head
      :kick="$t(copy.pickKick)"
      :title="$t(copy.pickTitle)"
      :sub="$t(copy.pickSub(accountLabel, stores.length))"></owner-head>

    <ul class="owner-store-list" :aria-label="$t(copy.pickKick)">
      <li v-for="store in stores" :key="store.storeCd">
        <button type="button" class="owner-store" :data-store-cd="store.storeCd" @click="$emit('enter', store.storeCd)">
          <span class="owner-store-mark" aria-hidden="true">{{ store.storeNm.slice(0, 1) }}</span>
          <span class="owner-store-text">
            <span class="owner-store-name">{{ store.storeNm }}</span>
            <span class="owner-store-id">{{ $t(copy.pickStoreId(store.storeId)) }}</span>
          </span>
          <span class="owner-store-enter">{{ $t(copy.pickEnter) }}</span>
        </button>
      </li>
    </ul>

    <div class="error-messages">
      <div v-if="error" id="owner-pick-msg" class="msg">{{ error }}</div>
    </div>

    <div class="owner-links">
      <el-button type="text" class="owner-other-account" @click="$emit('other-account')">{{
        $t(copy.pickOtherAccount)
      }}</el-button>
    </div>
  </div>
</template>

<script>
import OwnerHead from '@/components/login/OwnerHead.vue'
import { OWNER_COPY } from '@/utils/ownerCopy'

/**
 * 사장님 로그인 뒤 매장이 여럿일 때 — 줄마다 매장 이름·「매장 번호 S…」·[들어가기 →]. 누르면 무엇을 할지(`login/owner/store`)는 로그인 화면이
 * 정한다. 끝은 둘이다: `enter(storeCd)` · `other-account`(로그인 칸으로).
 */
export default {
  name: 'OwnerStorePicker',
  components: { OwnerHead },
  props: {
    /** 계정 표시 — 친 휴대폰 번호(하이픈)·이메일, 없으면 서버가 가린 아이디 */
    accountLabel: { type: String, default: '' },
    /** `[{storeCd, storeId, storeNm}]` — `utils/ownerLogin.ownerLoginViewOf` 가 읽은 것 */
    stores: { type: Array, required: true },
    /** 매장에 들어가지 못한 한 줄(번역된 것) — 빈 글자면 칸이 서지 않는다 */
    error: { type: String, default: '' },
  },
  data() {
    return { copy: OWNER_COPY }
  },
}
</script>

<style scoped>
.owner-picker {
  text-align: left;
  padding-top: 8px;
}
.owner-store-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.owner-store-list li + li {
  margin-top: 8px;
}
.owner-store {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 56px;
  padding: 8px 12px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-sm);
  background: var(--color-bg-card);
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: var(--color-text-primary);
}
.owner-store:hover {
  background: var(--color-primary-light);
}
.owner-store-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--color-primary-lighter);
  color: var(--color-primary-dark);
  font-weight: 700;
}
.owner-store-text {
  flex: 1;
  min-width: 0;
}
.owner-store-name {
  display: block;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.owner-store-id {
  display: block;
  font-size: 12px;
  color: var(--color-text-secondary);
}
.owner-store-enter {
  flex-shrink: 0;
  font-size: 14px;
  color: var(--color-primary);
}
.error-messages {
  margin: 15px 0 5px;
  min-height: 20px;
}
.msg {
  font-size: 14px;
  line-height: 18px;
  color: red;
}
.owner-links {
  text-align: center;
  padding-bottom: 20px;
}
</style>
